/** Announcement Bar — tone paint + optional show window (from/until). */

export const ANNOUNCEMENT_TONE_VALUES = ['info', 'notice', 'promo'] as const;
export type AnnouncementTone = (typeof ANNOUNCEMENT_TONE_VALUES)[number];

export const ANNOUNCEMENT_DEFAULT_TONE: AnnouncementTone = 'info';

/** Live-slot id baked into HTML for schedule evaluation at serve / client. */
export const ANNOUNCEMENT_LIVE_SLOT = 'announcement-bar';

export function parseAnnouncementTone(raw: string | undefined | null): AnnouncementTone {
  const value = (raw ?? '').trim().toLowerCase();
  if ((ANNOUNCEMENT_TONE_VALUES as readonly string[]).includes(value)) {
    return value as AnnouncementTone;
  }
  return ANNOUNCEMENT_DEFAULT_TONE;
}

/**
 * Empty from/until = no time filter (Visibility + message still apply).
 * Only from = from that instant onward. Only until = until that instant.
 */
export function isAnnouncementScheduleActive(
  startsAt: string | undefined | null,
  endsAt: string | undefined | null,
  nowMs: number = Date.now(),
): boolean {
  const startRaw = (startsAt ?? '').trim();
  const endRaw = (endsAt ?? '').trim();
  if (!startRaw && !endRaw) return true;

  if (startRaw) {
    const start = Date.parse(startRaw);
    if (Number.isFinite(start) && nowMs < start) return false;
  }
  if (endRaw) {
    const end = Date.parse(endRaw);
    if (Number.isFinite(end) && nowMs >= end) return false;
  }
  return true;
}
